exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".medicalStaff[data-v-bce8ebb6]{font-size:14px}.item[data-v-bce8ebb6]{border-bottom:1px solid #d9e0e6;height:200px;width:100%;padding:15px 30px;overflow:hidden}.item img[data-v-bce8ebb6]{height:170px;width:295px;display:inline-block;float:left}.item .content[data-v-bce8ebb6]{margin-left:25px;display:inline-block;font-size:16px;float:left;color:rgba(72,72,72,.5);overflow:hidden}.item .content .title[data-v-bce8ebb6]{color:#000;font-size:20px;margin-bottom:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-bce8ebb6","scoped":true,"sourceMap":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/education/educationPlan/parts/detail.vue
// module id = z9c8
// module chunks = 0